<div class="overlay">
  <div class="overlay__wrapper">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>


